import { render, staticRenderFns } from "./BillingNotice.vue?vue&type=template&id=966d283a&"
import script from "./BillingNotice.vue?vue&type=script&lang=js&"
export * from "./BillingNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports